import ReactDOM from 'react-dom';
import App from './App';
import { store } from './store/store';
import { Provider } from 'react-redux';
import './styles/index.scss';

export const checkoutWidget = {
    new: config => {
        return {
            render: () => {
                ReactDOM.render(
                    <>
                        <Provider store={store}>
                            <App data={config} />
                        </Provider>
                    </>,
                    document.querySelector(config.selector)
                );
            },
        };
    },
};

function onLogin() {
    alert('Login from outside');
}

window['BindIDme'] = () => {};

if (process.env.NODE_ENV === 'development') {
    window.tealium_data2track = [];

    //configurator object
    var config = {
        selector: '#root',
        langUrl: '/data/langUrl_label.json',
        lang: 'en',
        country: 'US',
        linkPrivacyPolicy: 'https://google.com',
        linkTermCondition: 'https://google.com',
        linkHome: 'https://google.com',
        linkEyeGlasses: 'https://google.com',
        linkSunGlasses: 'https://google.com',
        linkConditionUseSale: 'https://google.com',
        linkPrivacyNotice: 'https://google.com',
        linkCookieAndInternetAdvertising: 'https://google.com',
        linkContinueShopping: 'https://google.com',
        mockRequests: false,
        hostname: 'https://uat2.glasses.com',
        pagesUrl: {
            cart: '/CartView',
            shipping: '/ShippingBillingView',
            payment: '/PaymentView',
            typ: '/ConfirmationView',
        },
        orderId: '', //'502272966997',
        email: '', //'f.molteni@xister.com',
        enabledShippingModes: [
            'Green Delivery',
            'Standard Delivery',
            'Express Delivery',
            'Ship to store',
        ], //insert here 'shipModeCode' of the enabled shipping modes
        brand: 'GL',
        storeId: '15951',
        catalogId: '22101',
        langId: '-1',
        opthyPromoCode: 'Opthy10',
        form: {
            dob_field: false,
        },
        insurance: {
            rxInsurable: true, //true/false
            frameOnlyInsurable: true, //true/false
            noPrescriptionInsurable: true, //true/false
        },
        autocomplete: 'off',
        onBehalfSession: false, //true o false
        callFromComponentToGl: {
            onLogin: () => {
                onLogin();
                window.globalMethods.backFromLogin();
            },
            onCreateAccount: () => {
                alert('create account');
                window.globalMethods.backFromCreateAccount();
            },
            hideHeaderFooter: value => {
                console.log('hide header e footer', value);
            },
            editOrderItem: (
                frameId,
                lensesAddonsIds,
                orderId,
                orderItemId,
                orderItemIndex,
                eppCatEntryId
            ) => {
                /*GlassesManager.initRXC(
                    frameId,
                    lensesAddonsIds,
                    orderId,
                    orderItemId,
                    orderItemIndex,
                    eppCatEntryId
                );*/
            },
            getUpsellOptions: _dataInput => {
                alert('getUpsellOptions');
            },
            onInsuranceOpening: () => {
                //aprire modale insurance
                alert('onInsuranceOpening');
                window.globalMethods.onInsuranceClosing(true); //funzione da richiamare alla chiusura dell'insurance. Passare true se l'insurance è stata correttamente inserita
                //Passare false se l'insurance non è stata inserita correttamente
            },
            onRecalculateInsurance: () => {
                alert('onRecalculateInsurance');
                window.globalMethods.onRecalculateInsuranceEnd(true); //funzione da richiamare alla chiusura dell'insurance. Passare true se l'insurance è stata correttamente inserita
                //Passare false se l'insurance non è stata inserita correttamente
            },
            calculateInsuranceOnLoading: () => {
                //funzione da richiamare per il ricalcolo dell'insurance al loading
            },
            onApplePayButtonClicked: () => {
                //funzione da richiamare al click dell'ApplePay Button
            },
        },
        reCaptcha: {
            siteKey: '6LdlE5IbAAAAAFRmK8AHy-ihJ7AaY6VcNr8b7XkZ', //public recaptcha key of the site
            theme: 'dark', //dark, light
            size: 'invisible', //compact, normal or invisible
            enabled: 'true', //true, false
        },
        paypal: {
            clientKey: 'sb',
            locale: 'en_US',
            PAYPAL_EXPRESS_CHECKOUT_URL:
                '/webapp/wcs/stores/servlet/PayPalSetExpressCheckoutGL?catalogId={{0}}&langId={{1}}&storeId={{2}}&orderId={{3}}&cartMode=true',
            PAYPAL_CHECKOUT_URL:
                '/webapp/wcs/stores/servlet/PayPalSetExpressCheckoutGL?catalogId={{0}}&langId={{1}}&storeId={{2}}&orderId={{3}}&cartMode=true',
            PAYPAL_RETURN_URL_CART:
                '/webapp/wcs/stores/servlet/PayPalGetExpressCheckoutDetailsAddressUpdateCartGL?orderId={{0}}&catalogId={{1}}&storeId={{2}}&token={{3}}',
            PAYPAL_RETURN_URL:
                '/webapp/wcs/stores/servlet/PayPalGetExpressCheckoutDetailsAddressUpdateGL?orderId={{0}}&catalogId={{1}}&storeId={{2}}&token={{3}}',
        },
        affirm: {
            apiKey: 'T1EMSYOHGPZIT0RZ',
            script: 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js',
            totalThresholdVal: 50,
            initiateCheckoutTemplateURL:
                '/AffirmInitiateCheckoutGL?catalogId={0}&langId={1}&storeId={2}&orderId={3}',
            authorizeTemplateURL:
                '/AffirmAuthorizeGL?catalogId={0}&langId={1}&storeId={2}&orderId={3}',
        },
        klarna: {
            enabled: false,
            klarnaDataClientId: '793cda07-3878-5b0d-84f5-29380231f88f',
            klarnaSrc: 'https://na-library.playground.klarnaservices.com/lib.js',
            forwardUrl: '/KlarnaForward',
            updateSessionUrl: '/KlarnaUpdateSession',
            authorizePaymentUrl: '/AuthorizeKlarnaPayment',
            website: 'https://www.klarna.com/us/customer-service/',
            script: 'https://x.klarnacdn.net/kp/lib/v1/api.js',
            hostname: 'https://api-na.playground.klarna.com',
            locale: 'en-US',
            redirectUrl:
                '/PaymentView?catalogId=22101&langId=-1&storeId=15951&klarnaError=true&status=CANCELLED',
        },
        IDMe: {
            dataScope: '',
            dataClientId: '',
            dataRedirect: '',
        },
        storeUniqueID: '15951', //glasses
        assetsUrl: 'https://assets.glasses.com/is/image/Glasses/',
        instalmentsLink: '',
        bossApp: {
            enabled: true,
            googleApiKey: 'AIzaSyBYKlTpu53k5g-bkUSwS5ZHOJbttikH800',
        },
        sms: {
            enabled: true,
        },
        cartLensUpsell: {
            enabled: true,
        },
    }; //init and render widget

    var myWidget = checkoutWidget.new(config);
    myWidget.render();

    // window.globalMethods.prova(); //restore for simulate react component method call
}
